export default __webpack_public_path__ + "static/media/goshen40.87352246.jpg";